export default __webpack_public_path__ + "static/media/officeFloorPlan.ead8e69d.png";